import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { text } from '../text';
import { components } from '../components';
import { theme } from '../constants';
import { svg } from '../assets/svg';
import { MessageSvg } from '../assets/svg/MessageSvg';
import { LocationSvg2 } from '../assets/svg/LocationSvg2';
import { viewLeadProfile } from '../environment';
import useApi from '../customHook/useApi';




type Profile = {
    leadId: string | null;
    full_name: string | null;
    email: string | null;
    phone_number: string | null;
    gender: string | null;
    dob: string | null;
    pref_budget_min_range: number | null;
    pref_budget_max_range: number | null;
    pref_city_name: string | null;
    pref_city_id: string | null;
    pref_locality_name: string | null;
    pref_locality_id: string | null;

}

export interface profileResponse {
    success: boolean;
    statusCode: number;
    data: Profile;
    message?: string;
}


export const ContactUs: React.FC = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
    }, [pathname]);

    const [formData, setFormData] = React.useState({
        full_name: '',
        email: ''
    });



    // api call here 
    const {
        data: profileData,
        loading: profileLoading,
        callApi: fetchProfile,
    } = useApi<profileResponse>(viewLeadProfile, {
        method: "POST",
        autoCall: false,
        dependencies: [],
    });


    useEffect(() => {
        const leadId = localStorage.getItem("lead_profile_id");
        if (leadId) {
            fetchProfile({ leadId });
        }
    }, []);


    useEffect(() => {
        if (profileData?.data) {
            const data = profileData.data;
            setFormData({
                full_name: data.full_name ?? '',
                email: data.email ?? '',
            });
        }
    }, [profileData]);


    // Start Component here 

    const renderHeader = (): JSX.Element => {
        return (
            <components.Header
                title='Contact Us'
                goBack={true}
            />
        );
    };






    const renderContent = (): JSX.Element => {
        return (
            <main className='container' style={{ paddingBottom: 0 }}>
                <div style={{ marginTop: '10%', marginBottom: 20 }}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <img
                            alt='Success'
                            src={require('../assets/other/contactus.jpg')}
                            style={{ width: '100%', height: 'auto', marginBottom: "20px" }}
                        />

                    </div>
                    <text.H5 style={{ marginBottom: 5 }}>We're here to help!</text.H5>
                    <text.T14 style={{ marginBottom: 20 }}>
                        If you have any questions, feedback, or need assistance, feel free to contact us using the details below.
                    </text.T14>

                    <div className="contact-container">
                        <a href='tel:+919876543210' className="contact-box" style={{ textDecoration: "none", color: "inherit" }}>
                            <div className="icon-circle">
                                <svg.CallSvg />
                            </div>
                            <p>Call Us</p>
                        </a>
                        <a href="mailto:support@nestfin.app" className="contact-box" style={{ textDecoration: "none", color: "inherit" }}>
                            <div className="icon-circle">
                                <MessageSvg size={30} />
                            </div>
                            <p>Email Us</p>
                        </a>
                        <a href="https://www.google.com/maps?q=Nestfin+Pvt+Ltd+Bangalore"
                            target="_blank"
                            rel="noopener noreferrer" className="contact-box" style={{ textDecoration: "none", color: "inherit" }}>
                            <div className="icon-circle">
                                <LocationSvg2 size={25} />
                            </div>
                            <p>Location</p>
                        </a>
                    </div>

                    <div className='contactFrom'>
                        <form action="" onSubmit={(e) => e.preventDefault()} style={{ margin: "14px" }}>
                            <p style={{ fontWeight: "bold", fontSize: "19px", display: "block", marginBottom: "20px", textAlign: "center" }}>
                                Quick Contact
                            </p>

                            <div style={{ marginBottom: "10px" }}>
                                <label  >Name *</label>
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Your Name"
                                    required
                                    style={{
                                        width: "100%",
                                        padding: "12px 15px",
                                        border: "1px solid rgb(204 204 204 / 32%)",
                                        borderRadius: "4px",
                                        fontSize: "14px",
                                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
                                    }}
                                    value={formData.full_name}
                                    onChange={(e) =>
                                        setFormData((prev) => ({ ...prev, full_name: e.target.value }))
                                    }
                                />
                            </div>

                            <div style={{ marginBottom: "10px" }}>
                                <label  >Email *</label>
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Your Email"
                                    required
                                    style={{
                                        width: "100%",
                                        padding: "12px 15px",
                                        border: "1px solid rgb(204 204 204 / 32%)",
                                        borderRadius: "4px",
                                        fontSize: "14px",
                                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
                                    }}
                                    value={formData.email}
                                    onChange={(e) =>
                                        setFormData((prev) => ({ ...prev, email: e.target.value }))
                                    }
                                />
                            </div>

                            <div style={{ marginBottom: "10px" }}>
                                <label  >Message *</label>
                                <textarea
                                    name="message"
                                    placeholder="Your Message"
                                    // rows="4"
                                    required
                                    style={{
                                        width: "100%",
                                        padding: "12px 15px",
                                        border: "1px solid rgb(204 204 204 / 32%)",
                                        borderRadius: "4px",
                                        resize: "vertical",
                                        fontSize: "14px",
                                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
                                    }}
                                ></textarea>
                            </div>
                            <div style={{ textAlign: "right" }}>
                                <button
                                    type="submit"
                                    style={{
                                        padding: "0.5rem 1rem",
                                        backgroundColor: "#7065F0",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: "4px",
                                        fontSize: "14px",
                                        cursor: "pointer",
                                        textAlign: 'left'
                                    }}
                                >
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </main>
        );
    };

    return (
        <>
            {renderHeader()}
            {renderContent()}
        </>
    );
};




// before api call
// import React, { useEffect } from 'react';
// import { useLocation } from 'react-router-dom';
// import { text } from '../text';
// import { components } from '../components';
// import { theme } from '../constants';
// import { svg } from '../assets/svg';
// import { MessageSvg } from '../assets/svg/MessageSvg';
// import { LocationSvg2 } from '../assets/svg/LocationSvg2';

// export const ContactUs: React.FC = () => {
//     const { pathname } = useLocation();

//     useEffect(() => {
//         window.scrollTo(0, 0);
//         document.documentElement.scrollTop = 0;
//     }, [pathname]);




//     // Start Component here

//     const renderHeader = (): JSX.Element => {
//         return (
//             <components.Header
//                 title='Contact Us'
//                 goBack={true}
//             />
//         );
//     };






//     const renderContent = (): JSX.Element => {
//         return (
//             <main className='container' style={{ paddingBottom: 0 }}>
//                 <div style={{ marginTop: '10%', marginBottom: 20 }}>
//                     <div
//                         style={{
//                             display: 'flex',
//                             flexDirection: 'column',
//                             alignItems: 'center',
//                         }}
//                     >
//                         <img
//                             alt='Success'
//                             src={require('../assets/other/contactus.jpg')}
//                             style={{ width: '100%', height: 'auto', marginBottom: "20px" }}
//                         />

//                     </div>
//                     <text.H5 style={{ marginBottom: 5 }}>We're here to help!</text.H5>
//                     <text.T14 style={{ marginBottom: 20 }}>
//                         If you have any questions, feedback, or need assistance, feel free to contact us using the details below.
//                     </text.T14>

//                     <div className="contact-container">
//                         <a href='tel:+919876543210' className="contact-box" style={{ textDecoration: "none", color: "inherit" }}>
//                             <div className="icon-circle">
//                                 <svg.CallSvg />
//                             </div>
//                             <p>Call Us</p>
//                         </a>
//                         <a href="mailto:support@nestfin.app" className="contact-box" style={{ textDecoration: "none", color: "inherit" }}>
//                             <div className="icon-circle">
//                                 <MessageSvg size={30} />
//                             </div>
//                             <p>Email Us</p>
//                         </a>
//                         <a href="https://www.google.com/maps?q=Nestfin+Pvt+Ltd+Bangalore"
//                             target="_blank"
//                             rel="noopener noreferrer" className="contact-box" style={{ textDecoration: "none", color: "inherit" }}>
//                             <div className="icon-circle">
//                                 <LocationSvg2 size={25} />
//                             </div>
//                             <p>Location</p>
//                         </a>
//                     </div>

//                     <div className='contactFrom'>
//                         <form action="" onSubmit={(e) => e.preventDefault()} style={{ margin: "14px" }}>
//                             <p style={{ fontWeight: "bold", fontSize: "19px", display: "block", marginBottom: "20px", textAlign: "center" }}>
//                                 Quick Contact
//                             </p>

//                             <div style={{ marginBottom: "10px" }}>
//                                 <label  >Name *</label>
//                                 <input
//                                     type="text"
//                                     name="name"
//                                     placeholder="Your Name"
//                                     required
//                                     style={{
//                                         width: "100%",
//                                         padding: "12px 15px",
//                                         border: "1px solid rgb(204 204 204 / 32%)",
//                                         borderRadius: "4px",
//                                         fontSize: "14px",
//                                         boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
//                                     }}
//                                 />
//                             </div>

//                             <div style={{ marginBottom: "10px" }}>
//                                 <label  >Email *</label>
//                                 <input
//                                     type="email"
//                                     name="email"
//                                     placeholder="Your Email"
//                                     required
//                                     style={{
//                                         width: "100%",
//                                         padding: "12px 15px",
//                                         border: "1px solid rgb(204 204 204 / 32%)",
//                                         borderRadius: "4px",
//                                         fontSize: "14px",
//                                         boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
//                                     }}
//                                 />
//                             </div>

//                             <div style={{ marginBottom: "10px" }}>
//                                 <label  >Message *</label>
//                                 <textarea
//                                     name="message"
//                                     placeholder="Your Message"
//                                     // rows="4"
//                                     required
//                                     style={{
//                                         width: "100%",
//                                         padding: "12px 15px",
//                                         border: "1px solid rgb(204 204 204 / 32%)",
//                                         borderRadius: "4px",
//                                         resize: "vertical",
//                                         fontSize: "14px",
//                                         boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
//                                     }}
//                                 ></textarea>
//                             </div>
//                             <div style={{ textAlign: "right" }}>
//                                 <button
//                                     type="submit"
//                                     style={{
//                                         padding: "0.5rem 1rem",
//                                         backgroundColor: "#7065F0",
//                                         color: "#fff",
//                                         border: "none",
//                                         borderRadius: "4px",
//                                         fontSize: "14px",
//                                         cursor: "pointer",
//                                         textAlign: 'left'
//                                     }}
//                                 >
//                                     Submit
//                                 </button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             </main>
//         );
//     };

//     return (
//         <>
//             {renderHeader()}
//             {renderContent()}
//         </>
//     );
// };





// OLD CODE HERE
// import React, { useEffect } from 'react';
// import { useLocation } from 'react-router-dom';

// import { text } from '../text';
// import { components } from '../components';



// const privacyPolicy = [
//     {
//         id: 1,
//         title: '1. Introduction',
//         content:
//             'We value your privacy and are committed to protecting your personal data. This Privacy Policy outlines how we collect, use, and safeguard your information when you use our PG booking platform.',
//     },
//     {
//         id: 2,
//         title: '2. Information We Collect',
//         content:
//             'We may collect personal details including your name, contact number, email, gender, and location preferences when you use our services. We may also collect location data (with your permission) to show PGs near you.',
//     },
//     {
//         id: 3,
//         title: '3. How We Use Your Information',
//         content:
//             'We use your data to provide personalized PG recommendations, communicate booking-related information, improve user experience, and send important service-related updates. Your information is never sold to third parties.',
//     },
//     {
//         id: 4,
//         title: '4. Sharing of Information',
//         content:
//             'We may share your data with PG owners or partners solely for the purpose of booking or inquiry. We do not share your personal information for any marketing or unrelated third-party services.',
//     },
//     {
//         id: 5,
//         title: '5. Cookies and Tracking',
//         content:
//             'We use cookies to enhance your browsing experience and gather analytics to improve our platform. You may choose to disable cookies via your browser settings, though this may affect functionality.',
//     },
//     {
//         id: 6,
//         title: '6. Security',
//         content:
//             'We implement appropriate technical and organizational measures to protect your data from unauthorized access, alteration, disclosure, or destruction.',
//     },
//     {
//         id: 7,
//         title: '7. Your Rights',
//         content:
//             'You have the right to access, correct, or delete your personal information at any time. You may also request that we stop using your data for certain purposes.',
//     },
//     {
//         id: 8,
//         title: '8. Changes to This Policy',
//         content:
//             'We may update this Privacy Policy periodically. We encourage you to review this page from time to time for any changes.',
//     },
//     {
//         id: 9,
//         title: '9. Contact Us',
//         content:
//             'If you have any questions or concerns about this Privacy Policy or how your data is handled, please contact us at support@yourpgplatform.com.',
//     },
// ];


// export const ContactUs: React.FC = () => {
//     const location = useLocation();
//     const { pathname } = useLocation();

//     useEffect(() => {
//         const scrollToTop = () => {
//             window.scrollTo(0, 0);
//             document.documentElement.scrollTop = 0;
//         };

//         scrollToTop();
//     }, [pathname]);

//     const renderImageBackground = (): JSX.Element => {
//         return <components.Background version={1} />;
//     };

//     const renderHeader = (): JSX.Element => {
//         return (
//             <components.Header
//                 title='Contact Us'
//                 goBack={true}
//             />
//         );
//     };

//     const renderContent = (): JSX.Element => {
//         return (
//             <main
//                 className='container'
//                 style={{ paddingBottom: 0 }}
//             >
//                 <div style={{ marginTop: '10%', marginBottom: 20 }}>
//                     {privacyPolicy.map((item) => {
//                         return (
//                             <div
//                                 style={{ marginBottom: '10%' }}
//                                 key={item.id}
//                             >
//                                 <text.H5 style={{ marginBottom: 10 }}>{item.title}</text.H5>
//                                 <text.T14>{item.content}</text.T14>
//                             </div>
//                         );
//                     })}
//                 </div>
//             </main>
//         );
//     };

//     return (
//         <>

//             {renderHeader()}
//             {renderContent()}
//         </>
//     );
// };
